import React, {useState} from 'react';
import {useSelector} from "react-redux";
import loadingGif from '../assets/images/loader.gif';

const AdmissionDocumentPdf = ({admissionId, type, width=670, height=800, subType = false}) => {
    const idToken = useSelector(state => state.auth.idToken);
    const [downloading, setDownloading] = useState(false);
    const action = subType ? `${process.env.REACT_APP_API_PATH}/admission/${admissionId}/pdf/${type}/${subType}` : `${process.env.REACT_APP_API_PATH}/admission/${admissionId}/pdf/${type}/-`;

    const downloadPdf = () => {
        setDownloading(true);
        fetch(action, {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            body: `token=${encodeURIComponent(idToken)}`,
        })
            .then(response => {
                const disposition = response.headers.get('Content-Disposition') || '';
                let filename = `admission_${admissionId}.pdf`;
                const match = disposition.match(/filename="?([^";]+)"?/i);
                if (match && match[1]) {
                    filename = match[1].trim();
                }
                return response.blob().then(blob => ({blob, filename}));
            })
            .then(({blob, filename}) => {
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            })
            .finally(() => setDownloading(false));
    };

    return (
        <div>
            <div style={{marginBottom: '8px'}}>
                <button className="btn btn-sm btn-secondary" onClick={downloadPdf} disabled={downloading}>
                    {downloading ? <><img src={loadingGif} /> <span>Downloading...</span></> : 'Download PDF'}
                </button>
            </div>
            <iframe style={{border: "none"}} width={width} height={height} src={`data:text/html,<form id="pdf" method="POST" action="${action}">
                                    <input type="hidden" name="token" value="${idToken}" />
                                        </form>
                                        Loading...
                                        <script language="JavaScript">
                                            document.forms.pdf.submit();
                                        </script>`} />
        </div>
    )
}

export default AdmissionDocumentPdf;